import React from "react";
import "../../index.css";
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import angelmoroni from '../../Assets/Img/angelmoroni.jpg'

const Chap3 = () => {
  return (
    <div className="chapter-container">

      <div className="chapterFooter">
        <Link to="/Chap2">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap4">Next</Link>
      </div>

      <h1 className="chapterHeading">Chapter 3: Joseph’s Visionary Prowess</h1>

      <img src={angelmoroni} className='image' alt='Angel Moroni appearing to Joseph Smith' />

    <div className="wrapper">

      <div className="paragraph">
        <p>
          Joseph’s vision of building the Kingdom of God was expansive and
          impressive. From his small band of followers in the 1830s, Joseph
          believed that the kingdom he was establishing would grow in power and
          might. The Mormons would bring to pass the “literal gathering of
          Israel and … the restoration of the Ten Tribes; that Zion (the New
          Jerusalem) will be built on the American continent.” 
          <btn id="clickable1" className="footnote">1  </btn>
          <Tooltip anchorSelect="#clickable1"className="footnote-size"  clickable>Tenth Article of Faith.</Tooltip>
          
          Then the stage
          would be set for the latter-day events prophesied in the Bible, and
          Christ would appear and usher in the Millennium.
        </p>
      </div>

      <div className="paragraph">
        <p>
          Building the Kingdom of God requires builders. It would be necessary
          to gather the elect of God, the righteous leaven of the earth, to a
          central location. Joseph revealed, “Hearken, O ye elders of my church,
          saith the Lord your God, who have assembled yourselves together … in
          this land … which I have appointed and consecrated for the gathering
          of the saints. Wherefore, this is the land of promise, and the place
          for the city of Zion.”
          <btn id="clickable2" className="footnote">2  </btn>
          <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>D&C 57:1-2.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Joseph took inspiration from Isaiah, “And it shall come to pass in the
          last days, that the mountain of the Lord’s house shall be established
          in the top of the mountains and shall be exalted above the hills; and
          all nations shall flow unto it.” 
          <btn id="clickable3" className="footnote">3  </btn>
          <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>Isaiah 2:2.</Tooltip>
          
          From Joseph’s Book of Mormon, Nephi
          prophesied, “And the time cometh speedily that the righteous must be
          led up as calves of the stall, and the Holy One of Israel must reign
          in dominion, and might, and power, and great glory. And he gathereth
          his children from the four quarters of the earth.” 
          <btn id="clickable4" className="footnote">4  </btn>
          <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>2 Nephi 22:24-25.</Tooltip>

          According to
          Joseph, that location was Jackson County, Missouri. Joseph revealed,
          “I will give it unto you for the land of your inheritance, if you seek
          it with all your hearts. And this shall be my covenant with you.”
          <btn id="clickable5" className="footnote">5  </btn>
          <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>D&C 38:18-20.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Joseph’s revelations led early Mormons to believe that they were
          inheriting sacred land that they would possess forever, into the
          Millennium. The lands around Jackson County were the location of the
          Garden of Eden. According to Joseph, after Adam and Eve left the
          garden, human civilizations began to spread from this location. Just
          before the Second Coming, a great council would be held nearby at
          Adam-ondi-Ahman where Adam would bless his posterity.
        </p>
      </div>

      <div className="paragraph">
        <p>
          You can imagine the early Mormons’ surprise several years later when
          they were driven from their “everlasting inheritances”
          <btn id="clickable6" className="footnote">6  </btn>
          <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>D&C 57:5.</Tooltip>
           which had been
          given to them by their prophet through a revelation from Christ.
        </p>
      </div>

      <h2 className="headlinePadding" >Zion Reared in the First Generation of Early Mormons</h2>

      <div className="paragraph">
        <p>
          According to the church today, its mission is to help “all of God’s
          children come to Jesus Christ through learning about His gospel,
          making and keeping promises with God (covenants), and practicing
          Christlike love and service.” But that is not the original mission of
          the church.
        </p>
      </div>

      <div className="paragraph">
        <p>
          According to Mormon scripture and Joseph’s prophetic utterances, the
          purpose of the restoration was the gathering of the righteous elect
          from the four corners of the earth. To make them kings and priests,
          and queens and priestesses. To establish a physical, temporal Kingdom
          of God in the holy city, which would serve as a refuge for the
          righteous in the last days prior to Christ’s Second Coming – where the
          world and its wickedness would be consumed in the fire and light and
          Christ’s presence. Much more exciting!
        </p>
      </div>

      <div className="paragraph">
        <p>
          Joseph revealed in 1832 that the establishment of Zion was to take
          place within the lifetime of the early church members, to be “reared
          in this generation.” 
          <btn id="clickable7" className="footnote">7  </btn>
          <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>D&C 97:19.</Tooltip>
          
          The 1832 revelation states, “Yea, the word of the
          Lord concerning his church, established in the last days … for the
          gathering of his saints to stand upon Mount Zion, which shall be the
          city of New Jerusalem … even the place of the temple, which temple,
          shall be reared in this generation. For verily, this generation shall
          not all pass away until a house shall be built unto the Lord, and a
          cloud shall rest upon it, which cloud shall be even the glory of The
          Lord.”
          <btn id="clickable8" className="footnote">8  </btn>
          <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>D&C 97:19.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          When “the Lord” says “a cloud shall rest upon it, which cloud shall be
          even the glory of the Lord” imagine an intense shaft of heavenly light
          full of intelligence, knowledge, and spirit illuminating the holy
          city. Joseph taught of the future city, “Ye are come unto Mount Zion,
          and unto the city of the living God, the heavenly Jerusalem, and to an
          innumerable company of angels, to the general assembly and Church of
          the Firstborn.” 
          <btn id="clickable9" className="footnote">9  </btn>
          <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>Joseph Smith, Teaching of the Prophet Joseph Smith, p. 320.</Tooltip>
          
          The Church of the Firstborn refers to exalted beings
          who gain entrance into the highest degree of the Celestial Kingdom.
        </p>
      </div>

      <div className="paragraph">
        <p>
          If true, it sounds wonderful to be in this theophany – none of the
          earthly woes and sorrows we experience. All nations of the earth will
          look to the holy city of Zion. Joseph revealed in 1832, “And the
          nations of the earth shall honor her and shall say: Surely Zion is the
          city of our God, and surely Zion cannot fall, neither be moved out of
          her place, for God is there, and the hand of the Lord is there.”
          <btn id="clickable10" className="footnote">10  </btn>
          <Tooltip anchorSelect="#clickable10" className="footnote-size" clickable>D&C 84:1-5.</Tooltip>
        </p>
      </div>

      <h2 className="headlinePadding" >Mormons Redefine Generation</h2>

      <div className="paragraph">
        <p>
          In 1832, there were 2,661 Mormons. 
          <btn id="clickable11" className="footnote">11  </btn>
          <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>2013 Church Almanac, December 12, 2012.</Tooltip>
          
          According to this revelation, these
          2,661 Mormons would see Zion established. If a generation is 20-30 years, 
          <btn id="clickable12" className="footnote">12  </btn>
          <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>Jack Fenner, 28 March 2005, Cross-Cultural Estimation of the Human Generation Interval for Use in Genetics-Based Population Divergence Studies, American Journal of Physical Anthropology. 128: 415–423.</Tooltip>
          
          that would place the building of Zion between 1852 and 1862.
          Therefore, at the latest, the 1860s was the decade to watch. However,
          Zion was not established in Jackson County in the lifetimes of the
          early Mormons – during the 1860s. But as the decades passed, the
          Mormons continued to believe. Mormon apostle Orson Pratt stated in
          1870, “God promised in the year 1832 that we should, before this
          generation then living had passed away, return and build up the City
          of Zion in Jackson County … He promised us that He would manifest
          Himself on that temple, that the glory of God should be upon it.”
        </p>
      </div>

      <div className="paragraph">
        <p>
          Orson continued, “The Latter-day Saints just as much expect to receive
          a fulfillment of that promise during the generation that was in
          existence in 1832 as they expect that the sun will rise and set
          tomorrow. Why? Because God cannot lie.” 
          <btn id="clickable13" className="footnote">13  </btn>
          <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>Orson Pratt, Journal of Discourses, May 5, 1870, vol. 13, p. 362.</Tooltip>
          
          Orson stated in 1871 about the
          1832 revelation, “We just as much expect that a city will be built,
          called Zion … in the generation when this revelation was given; we
          just as much expect this as we expect the sun to rise in the morning
          and set in the evening … But say the objector, ‘thirty-nine years have
          passed away.’ What of that? The generation has not passed away; all
          the people that were living thirty-nine years ago have not passed
          away; but before they do pass away this will be fulfilled.” 
          <btn id="clickable14" className="footnote">14  </btn>
          <Tooltip anchorSelect="#clickable14" className="footnote-size" clickable>Orson Pratt, Journal of Discourses, April 9, 1871, vol. 14, p. 275.</Tooltip>
          
          Yet, it never happened.
        </p>
      </div>

      <div className="paragraph">
        <p>
          The early Mormons were promised that they would see Zion built and
          Christ return in their lifetimes. Lyman Johnson was promised that “He
          shall see the Savior come and stand upon the earth with power and
          great glory.” 
          <btn id="clickable15" className="footnote">15  </btn>
          <Tooltip anchorSelect="#clickable15" className="footnote-size" clickable>Documentary History of the Church vol 2; p. 188.</Tooltip>
          
          Heber Kimball was promised that “He may stand unto the coming of our Lord.”
          <btn id="clickable16" className="footnote">16  </btn>
          <Tooltip anchorSelect="#clickable16" className="footnote-size" clickable>Documentary History of the Church vol 2; p. 189.</Tooltip> 
          
          Orson Hyde was promised “That he may stand upon the earth and bring souls till Christ comes.” 
          <btn id="clickable17" className="footnote">17  </btn>
          <Tooltip anchorSelect="#clickable17" className="footnote-size" clickable>Documentary History of the Church vol 2; p. 190.</Tooltip>
          
          William Smith was
          blessed that “He shall be preserved and remain on the earth until
          Christ shall come to take vengeance on the wicked.”
          <btn id="clickable18" className="footnote">18  </btn>
          <Tooltip anchorSelect="#clickable18" className="footnote-size" clickable>Documentary History of the Church vol 2; p. 191.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          In 1935, 105 years (more than three generations) Mormon apostle Joseph
          Fielding Smith stated, “I firmly believe that there will be some of
          that generation who were living when this revelation was given (1832)
          who shall be living when this temple is reared. And I do not believe
          that the Lord has bound himself to accomplish the matter within 100
          years from 1832 … I have full confidence in the word of the Lord and
          that it shall not fail.”
          <btn id="clickable19" className="footnote">19  </btn>
          <Tooltip anchorSelect="#clickable19" className="footnote-size" clickable>Joseph Fielding Smith, The Way to Perfection, p. 270.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Still at it, then-prophet Joseph Fielding Smith stated in 1972 – 140
          years after the 1832 revelation (more than five generations), “It may
          be reasonable to assume that in giving this revelation to the prophet
          the Lord did have in mind the generation of people who would still be
          living within the one hundred years from the time of announcement of
          the revelation, and that they would enjoy the blessings of the temple,
          and a glorious cloud would rest upon it. It is also reasonable to
          believe that no soul living in 1832 is still living in mortality on
          the earth.” 
          <btn id="clickable20" className="footnote">20  </btn>
          <Tooltip anchorSelect="#clickable20" className="footnote-size" clickable>Joseph Fielding Smith, Answers to Gospel Questions, Vol. 4. p. 112.</Tooltip>
          
          Where did he come up with the 100-year requirement?
        </p>
      </div>

      <div className="paragraph">
        <p>
          The truth of the matter is that six years after the 1832 revelation,
          the Mormons were driven from Missouri in 1838. Large numbers of
          Mormons had poured into the state, announcing that the land settled
          and owned by the Missourians had been given to the Mormons by God for
          their everlasting inheritances. This naturally infuriated the
          Missourians. The threat of being displaced from their homes and farms
          created tensions. Missourians began violently pushing back against the
          Mormons. Omitted from church history lessons today, the Mormons pushed
          back violently as well – even criminally.
        </p>
      </div>

      <div className="paragraph">
        <p>
          Claiming the need to retaliate against the malevolent Missourians, the
          Mormons formed the Danites. This oath-bound group went about stealing
          and storing their plunder in bishop storehouses. Just as the
          Missourians were doing, the Mormon Danites destroyed Missourians’
          property, killing livestock, and burning barns.
        </p>
      </div>

      <div className="paragraph">
        <p>
          Hostilities increased to the point that the conflict was named the
          Mormon War. Finally, the governor issued the extermination order on
          October 27, 1838, stating, “… the Mormons must be treated as enemies,
          and must be exterminated or driven from the State if necessary for the
          public peace – their outrages are beyond all description.” 
          <btn id="clickable21" className="footnote">21  </btn>
          <Tooltip anchorSelect="#clickable21" className="footnote-size" clickable>John Green, 1839. Facts Relative to the Expulsion of the Mormons or Latter-Day Saints, from the State of Missouri, under the “Exterminating Order.”</Tooltip>
          
          The
          governor was echoing First Presidency Counselor Sidney Rigdon’s
          previous words, “And that mob that comes on us to disturb us, it shall
          be between us and them a war of extermination; for we will follow them
          until the last drop of their blood is spilled.”
          <btn id="clickable22" className="footnote">22  </btn>
          <Tooltip anchorSelect="#clickable22" className="footnote-size" clickable>Stephen LeSueur, The 1838 Mormon War in Missouri, pp. 37–43, 1990.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Between 1832 and 1838, both Mormons and Missourians were killed and
          beaten – all in an attempt to obey their prophet and establish Zion,
          God’s holy city. Eventually, Joseph and church leaders were imprisoned
          in Liberty Jail for war crimes. The Mormons had lost practically
          everything. In the dead of winter, Joseph’s followers fled for Nauvoo
          – their immediate hopes of building the holy city of Zion dashed.
        </p>
      </div>

      <div className="paragraph">
        <p>
          However, there was a silver lining for Joseph. The events of Missouri,
          and the maltreatment the Mormons endured, galvanized Joseph’s
          followers. The persecution they suffered carved a deep conviction that
          Mormonism was the true gospel into their souls. For decades and
          decades, Mormons would replay a one-sided persecution narrative over
          pulpits and talk of the Lord leading the Mormons back to their
          promised land one day.
        </p>
      </div>

      <div className="paragraph">
        <p>
          Brigham stated in 1845, “… as the Lord lives we will build up Jackson
          county in this generation.” 
          <btn id="clickable23" className="footnote">23  </btn>
          <Tooltip anchorSelect="#clickable23" className="footnote-size" clickable>Times and Seasons, 1 July 1845, vol. 6, p. 956.</Tooltip>
          
          First Presidency Counselor Heber Kimball
          stated in 1861 that in his lifetime, “Brethren, I shall go to Jackson
          County with thousands of this people who will be faithful.” 
          <btn id="clickable24" className="footnote">24  </btn>
          <Tooltip anchorSelect="#clickable24" className="footnote-size" clickable>Heber Kimball, Journal of Discourses, February 17, 1861, vol. 8, p. 350.</Tooltip>
          
          But what
          reason did Joseph give his followers for his failed revelations
          regarding the building of Zion? Christ had promised “… assemble
          yourselves together to rejoice upon the land of Missouri, which is the
          land of your inheritance, which is now the land of your enemies. But,
          behold, I, the Lord, will hasten the city in its time, and will crown
          the faithful with joy and with rejoicing.”
          <btn id="clickable25" className="footnote">25  </btn>
          <Tooltip anchorSelect="#clickable25" className="footnote-size" clickable>D&C 52:42.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Just as a treasure diviner blames the men digging for not following
          instructions, Joseph blamed the Mormons for their unrighteousness.
          “Behold … were it not for the transgressions of my people, speaking
          concerning the church and not individuals, they might have been
          redeemed even now. But behold, they have not learned to be obedient to
          the things which I required at their hands, but are full of all manner
          of evil … And are not united according to the union required by the
          law of the celestial kingdom.”
          <btn id="clickable26" className="footnote">26  </btn>
          <Tooltip anchorSelect="#clickable26" className="footnote-size"  clickable>D&C 105:2-4.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Later, we will review the dark history of the failed attempt to build
          Zion in greater detail.
        </p>
      </div>

      </div>

      <div className="chapterFooter">
        <Link to="/Chap2">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap4">Next</Link>
      </div>
      
    </div>
  );
};

export default Chap3;
